var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFaqPageArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 20,
    viewBox: "0 0 28 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6329_1844)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.7897 18.6795L27.1885 5.81763C28.2768 4.58544 28.2705 2.59265 27.1696 1.37567C26.2008 0.303215 24.6219 0.310821 23.6531 1.39088L15.7771 10.1911C14.802 11.2788 13.2168 11.2712 12.248 10.1911L4.36573 1.32243C3.38438 0.219548 1.78654 0.227154 0.817764 1.33764L0.792601 1.36807C-0.270531 2.58504 -0.270531 4.57023 0.805183 5.7796L12.248 18.6795C13.2231 19.7748 14.8146 19.7748 15.7897 18.6795Z",
    fill: "#231F20"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6329_1844"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19,
    height: 28,
    fill: "white",
    transform: "matrix(0 1 -1 0 28 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaqPageArrow);
export default __webpack_public_path__ + "static/media/FAQPage_arrow.ab574b16ebcbd197847c90f5cb85bab4.svg";
export { ForwardRef as ReactComponent };